/*
 * @Author: zerui.yao
 * @Date: 2023-10-23 15:01:55
 * @LastEditors: zerui.yao
 * @LastEditTime: 2023-12-28 14:39:37
 * @FilePath: /fed-authority/src/i18n/index.js
 * @Description:
 */
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import auth from '@/utils/auth';

import zhCN from './lang/zh-CN';
import enUS from './lang/en-US';

Vue.use(VueI18n);

const messages = {
  'zh-CN': { ...zhCN },
  'en-US': { ...enUS },
  // 'en-GB': enGB,
};

export const defaultLang = auth.getLocal();
const i18n = new VueI18n({
  locale: defaultLang,
  messages,
  silentTranslationWarn: true,
});

export default i18n;

function setI18nLanguage(lang) {
  i18n.locale = lang;
  document.querySelector('html').setAttribute('lang', lang.toLowerCase());
  return lang;
}

export function loadLanguageAsync(lang = defaultLang) {
  return new Promise((resolve) => {
    // 缓存语言设置
    if (i18n.locale !== lang) {
      return resolve(setI18nLanguage(lang));
    }
    return resolve(lang);
  });
}
